import App from '@/App.vue'
import { useAuthStore } from '@/modules/authStore/stores/authStore'
import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'
import { useCentrifugeStore } from '@/modules/centrifuge/stores/centrifugeStore'
import router from '@/router'
import '@/utils/axiosInterceptors'
import { registerPlugins } from '@core/utils/plugins'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

// Eruda mobile console overlay (disabled to prevent console log flood)

declare global {
  interface Window {
    __pwaPrompt?: any
  }
}

window.addEventListener('beforeinstallprompt', (e: any) => {
  e.preventDefault()
  window.__pwaPrompt = e
})

// Create vue app
const app = createApp(App)

const pinia = createPinia()

app.use(pinia)

/* Роутер стартует навигацию сразу. Пока права не пришли, гард не должен решать по пустому списку. */
const authEntry = /^\/(?:callback|login)\/?$/.test(window.location.pathname)
if (!authEntry)
  usePermissionsStore().beginPending()

app.use(router)

registerPlugins(app)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        console.log('[PWA] Service Worker registered:', reg.scope)
      })
      .catch(err => {
        console.warn('[PWA] Service Worker registration failed:', err)
      })
  })
}

const authStore = useAuthStore()

// Complete the callback before attempting IAM with any previous grant.
if (!authEntry) {
  const restored = await authStore.restoreAuth()
  if (!restored) usePermissionsStore().cancelPending()
  if (!restored && authStore.sessionError) await router.replace('/login')
}

try {
  const centrifugeStore = useCentrifugeStore()

  console.log('[MAIN] Initializing centrifuge...')
  if (authStore.isAuthenticated) await centrifugeStore.initCentrifuge()
  console.log('[MAIN] Centrifuge initialization completed')
} catch (e) {
  console.warn('[MAIN] Centrifugo init skipped', e)
}

app.mount('#app')
